import React, { useCallback, useEffect, useState } from "react";

import MobileLayout from "../../components/MobileLayout";
import { useAuth } from "../../hooks/auth";
import {
  listUserNotifications,
  UserInboxNotification,
} from "../../services/userInboxService";

import { Body, Item, ItemTitle, ItemBody, ItemMeta, Empty } from "./styles";

function formatTime(ts: number): string {
  try {
    return new Date(ts).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

const MyNotificationsPage: React.FC = () => {
  const { user } = useAuth();
  const [list, setList] = useState<UserInboxNotification[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.uid) {
      setList([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data = await listUserNotifications(user.uid);
      setList(data.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0)));
    } catch (e) {
      console.error(e);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [user?.uid]);

  useEffect(() => {
    load();
  }, [load]);

  if (!user?.uid) {
    return (
      <MobileLayout headerTitle="Notificações" headerType="private">
        <Body>
          <Empty>Faça login para ver suas notificações.</Empty>
        </Body>
      </MobileLayout>
    );
  }

  return (
    <MobileLayout
      headerTitle="Notificações"
      headerType="private"
      headerDescription="Mensagens enviadas para você no app"
    >
      <Body>
        {loading && <Empty>Carregando...</Empty>}
        {!loading && list.length === 0 && (
          <Empty>Nenhuma notificação por aqui.</Empty>
        )}
        {!loading &&
          list.map((n) => (
            <Item key={n.id} $read={n.read}>
              <ItemTitle>{n.title}</ItemTitle>
              <ItemBody>{n.body}</ItemBody>
              {n.timestamp ? (
                <ItemMeta>{formatTime(n.timestamp)}</ItemMeta>
              ) : null}
            </Item>
          ))}
      </Body>
    </MobileLayout>
  );
};

export default MyNotificationsPage;
